module.exports = __webpack_public_path__ + "static/media/kolorowanka_7.490b9cd9.png";